import { ContextKindKey } from '@gonfalon/contexts/types';

import type { Clause } from '../types';

export function getContextKind(clause: Clause) {
  return clause.contextKind || ContextKindKey.USER;
}
